import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import { Autocomplete, Popover, Button, Stack, TextField, Container } from '@mui/material';

// Calendario
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt-BR';

import { getGenericData, getUsuarios } from './api';
import { useUnidades } from '../hooks/useUnidades';

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroBasico = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState(props.filtro);
  const [usuarios, setUsuarios] = useState([]);
  const { unidades } = useUnidades();

  // Movimentacao Estoque
  const [fornecedor, setFornecedor] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const result = await getGenericData('fornecedor', {});
      setFornecedor(result);
    };
    fetchData();
  }, []);

  useEffect(() => {
    fectchUsuarios();
  }, []);
  const fectchUsuarios = async () => {
    const resultado = await getUsuarios();
    setUsuarios(resultado);
  };

  // Calendario
  // Calendario 1 (Data Inicial)
  const [openCalendar1, setOpenCalendar1] = useState(false);
  const handleCalendarOpen1 = () => {
    setOpenCalendar1(true);
  };
  const handleCalendarClose1 = () => {
    setOpenCalendar1(false);
  };
  const handleDateChange1 = (date) => {
    setFiltro({ ...filtro, datainicial: date });
    handleCalendarClose1(); // Feche o calendário após a seleção da data
  };

  // Calendario 2 (Data Final)
  const [openCalendar2, setOpenCalendar2] = useState(false);
  const handleCalendarOpen2 = () => {
    setOpenCalendar2(true);
  };
  const handleCalendarClose2 = () => {
    setOpenCalendar2(false);
  };
  const handleDateChange2 = (date) => {
    setFiltro({ ...filtro, datafinal: date });
    handleCalendarClose2(); // Feche o calendário após a seleção da data
  };
  // Calendario

  // Calendario Vencimento
  const [openCalendarVencimento, setOpenCalendarVencimento] = useState(false);
  const handleCalendarOpenVencimento = () => {
    setOpenCalendarVencimento(true);
  };
  const handleCalendarCloseVencimento = () => {
    setOpenCalendarVencimento(false);
  };
  const handleDateChangeVencimento = (date) => {
    setFiltro({ ...filtro, vencimento: date });
    handleCalendarCloseVencimento(); // Feche o calendário após a seleção da data
  };

  const handleConfirm = () => {
    props.onConfirm(filtro);
  };
  return (
    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{ height: 'auto' }}>
        <Stack direction={'row'} gap={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar1}
              onOpen={handleCalendarOpen1}
              onClose={handleCalendarClose1}
              value={filtro.datainicial}
              onChange={handleDateChange1}
              renderInput={(params) => <TextField {...params} label="Data Inicial" />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar2}
              onOpen={handleCalendarOpen2}
              onClose={handleCalendarClose2}
              value={filtro.datafinal}
              onChange={handleDateChange2}
              renderInput={(params) => <TextField {...params} label="Data Final" />}
            />
          </LocalizationProvider>
        </Stack>

        <Autocomplete
          disablePortal
          id="unidade"
          value={filtro.unidade || null}
          options={unidades}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Unidade" />}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, unidade: newValue });
          }}
        />

        
        {props.type !== 'dashboard' && (
          <Autocomplete
            disablePortal
            disabled={!JSON.parse(localStorage.getItem('userData')).supervisor}
            id="usuarioLogado"
            value={filtro.usuarioLogado}
            onChange={(event, newValue) => {
              setFiltro({ ...filtro, usuarioLogado: newValue });
            }}
            options={usuarios}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            getOptionLabel={(option) => `${option.nome}`}
            renderInput={(params) => <TextField {...params} label="Usuário" />}
          />
        )}

        {/* Despesas */}
        {(props.type === 'despesa' || props.type === 'receita') && (
          <>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
              <DatePicker
                open={openCalendarVencimento}
                onOpen={handleCalendarOpenVencimento}
                onClose={handleCalendarCloseVencimento}
                value={filtro.vencimento || null}
                onChange={handleDateChangeVencimento}
                renderInput={(params) => <TextField {...params} label="Vencimento" />}
              />
            </LocalizationProvider>
          </>
        )}

        {/* Movimentacao Estoque */}
        {props.type === 'movimentacaoestoque' && (
          <>
            <Autocomplete
              disablePortal
              id="fornecedor"
              value={filtro.fornecedor}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, fornecedor: newValue });
              }}
              options={fornecedor}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Fornecedor" />}
            />
          </>
        )}

        <Container sx={{ marginTop: 2 }}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
      </Stack>
    </Popover>
  );
});

PopoverFiltroBasico.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PopoverFiltroBasico;